import { denormalisedResponseEntities } from '../util/data';
import { createImageVariantConfig } from '../util/sdkLoader';
import { setCurrentUser } from './user.duck';
import { getFavouriteListingIds, toggleFavouriteListingId } from '../util/favourites';

export const toggleFavouriteListing = listingId => (dispatch, getState, sdk) => {
  const currentUser = getState().user?.currentUser;

  if (!currentUser || !listingId) {
    return Promise.reject(new Error('A signed-in user and listing id are required to save favourites.'));
  }

  const privateData = currentUser.attributes?.profile?.privateData || {};
  const currentIds = getFavouriteListingIds(currentUser);
  const favouriteListingIds = toggleFavouriteListingId(currentIds, listingId);

  const bodyParams = {
    privateData: {
      ...privateData,
      favouriteListingIds,
    },
  };
  const queryParams = {
    expand: true,
    include: ['profileImage'],
    'fields.image': ['variants.square-small', 'variants.square-small2x'],
  };

  return sdk.currentUser.updateProfile(bodyParams, queryParams).then(response => {
    const entities = denormalisedResponseEntities(response);
    if (entities.length !== 1) {
      throw new Error('Expected a current user in the favourites update response.');
    }

    dispatch(setCurrentUser(entities[0]));
    return favouriteListingIds;
  });
};

export const fetchFavouriteListings = (listingIds, config) => (dispatch, getState, sdk) => {
  const ids = Array.isArray(listingIds) ? listingIds.filter(Boolean) : [];
  if (ids.length === 0) {
    return Promise.resolve([]);
  }

  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config?.layout?.listingImage || {};
  const aspectRatio = aspectHeight / aspectWidth;

  const params = {
    ids,
    include: ['author', 'images'],
    'fields.listing': [
      'title',
      'price',
      'geolocation',
      'publicData.listingType',
      'publicData.transactionProcessAlias',
      'publicData.unitType',
      'publicData.cardStyle',
      'publicData.location',
      'publicData.serviceLocationType',
      'publicData.mobileServiceArea',
    ],
    'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
    'fields.image': [
      'variants.scaled-small',
      'variants.scaled-medium',
      `variants.${variantPrefix}`,
      `variants.${variantPrefix}-2x`,
    ],
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
    'limit.images': 1,
    perPage: Math.min(ids.length, 100),
  };

  return sdk.listings.query(params).then(response => {
    const listings = denormalisedResponseEntities(response);
    const order = new Map(ids.map((id, index) => [id, index]));

    return listings.sort((a, b) => {
      const aIndex = order.get(a?.id?.uuid) ?? Number.MAX_SAFE_INTEGER;
      const bIndex = order.get(b?.id?.uuid) ?? Number.MAX_SAFE_INTEGER;
      return aIndex - bIndex;
    });
  });
};
